/**
 * Form validation shared by every public form.
 *
 * There were three copies of `isValidEmail` and they did not agree: the audit
 * route required a two character top level domain, intake and the project
 * enquiry accepted one. This is the audit's version, because no real top level
 * domain is a single character, so "a@b.c" was only ever a typo getting through.
 * That makes the other two very slightly stricter than they were.
 */

/** The cap is the RFC 5321 maximum for a whole address, not a house rule. */
const MAX_EMAIL_LENGTH = 254;

export function isValidEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s) && s.length <= MAX_EMAIL_LENGTH;
}
